import React from "react";
import RoundButton from "../../../Common/RoundButton";
import { Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
const AdharSelfyForm = ({
  handleContinue,
  disable,
  handleImageClick,
  adharcardImage,
}: any) => {
  return (
    <>
      <div style={{ marginTop: "35px", marginBottom: "30px" }}>
        {adharcardImage !== undefined ? (
          <img src={adharcardImage} />
        ) : (
          <img
            onClick={handleImageClick}
            className="pancard-img"
            src={
              "https://cdn.kalingatv.com/wp-content/uploads/2020/11/aadhar-card.jpg"
            }
          />
        )}
      </div>
      <Typography className="fs-14 fw-500">
        Make sure you place your <span className="fw-700">Aadhar Card</span> inside
        the frame as shown as above
      </Typography>
      <div style={{ marginTop: "40px" }}>
        <RoundButton
          disable={disable}
          onClick={handleContinue}
          title={"Continue"}
        />
      </div>
    </>
  );
};

export default AdharSelfyForm;
